import type { Router } from 'vue-router'
import i18n from '@/lang'
/* 路由守卫拦截 */
const guards = (router: Router) => {
  router.beforeEach((to, from, next) => {
       (document as any).title = i18n.global.t(`page['校友录']`)
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      // 判断 localStorage 中是否有 access_token
      if (localStorage.getItem('token')) {
        next() // 有 token，继续访问
      } else {
        next('/login') // 无 token，跳转到登录页
      }
    }else {
      next(); // 不需要验证的路由，直接继续
     }
  })
}
export default guards
